/* Copyright (c) 2026 Xperi. All Rights Reserved. */

import { Locale } from "./Locale";
import { LocaleKeys } from "./LocaleKeys";

export { Locale, LocaleKeys };
